import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "mb-1" }
const _hoisted_7 = { class: "font-weight-bold" }
const _hoisted_8 = { class: "mb-1" }
const _hoisted_9 = { class: "font-weight-bold" }
const _hoisted_10 = { class: "mb-1" }
const _hoisted_11 = { class: "font-weight-bold" }
const _hoisted_12 = {
  key: 0,
  class: "my-3 d-flex"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "mt-3 text-center" }
const _hoisted_15 = { class: "mb-3 mt-1" }

import SpinnerVue from "@common/components/Spinner.vue";
import { computed, reactive, watch } from "vue";
import { useI18n } from "vue-i18n";

type ViewModel = {
  localOpenGeneratedCatalogue: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CatalogFinisherExternal',
  props: {
    generatedCatalogData: {},
    newCatalogName: {},
    errorPassed: {},
    existingCatalogName: {},
    openGeneratedCatalogue: { type: Boolean }
  },
  emits: ["update:openGeneratedCatalogue"],
  setup(__props: any, { emit }) {

const props = __props;

const { t } = useI18n();





//#region ViewModel
const vm = reactive<ViewModel>({
  localOpenGeneratedCatalogue: props.openGeneratedCatalogue ?? false
});
//#endregion

//#region Computed Errors
const errors = computed(() => ({
  NoArticlesInSourceCatalogue: `${t("ErrorMessage.NoArticlesInSourceCatalogue")}\n'${props.existingCatalogName || ""}'. ${t("ErrorMessage.NoCatalogueGenerated")}`,
  CatalogueNameExist: {
    title: t("ErrorMessage.CatalogueGenerationFailed"),
    message: t("ErrorMessage.CatalogueNameExist")
  }
}));
//#endregion

//#region Computed Properties
const openGeneratedCatalogueModel = computed({
  get: () => vm.localOpenGeneratedCatalogue,
  set: (val: boolean) => {
    vm.localOpenGeneratedCatalogue = val;
    emit("update:openGeneratedCatalogue", val);
  }
});
//#endregion

//#region Watch
watch(
  () => props.openGeneratedCatalogue,
  (val) => {
    if (val !== undefined) vm.localOpenGeneratedCatalogue = val;
  }
);
//#endregion

//#region Methods
const downloadCsv = () => {
  if (!props.generatedCatalogData) return;

  let csvContent = "data:text/csv;charset=utf-8,ArticleNo\n";
  props.generatedCatalogData.nonExistingArticles.forEach((value) => {
    csvContent += `${value}\n`;
  });

  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", props.newCatalogName ? `${props.newCatalogName}.csv` : "catalogue.csv");
  document.body.appendChild(link);
  link.click();
};
//#endregion

return (_ctx: any,_cache: any) => {
  const _component_b_btn = _resolveComponent("b-btn")!
  const _component_b_checkbox = _resolveComponent("b-checkbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    (props.generatedCatalogData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (props.errorPassed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (props.errorPassed === 'NoArticlesFromSourceInCatalog')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(errors.value.NoArticlesInSourceCatalogue), 1))
                  : (_ctx.errorPassed === 'CatalogNameExist')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("h3", null, _toDisplayString(errors.value.CatalogueNameExist.title), 1),
                        _createElementVNode("p", null, _toDisplayString(errors.value.CatalogueNameExist.message), 1)
                      ]))
                    : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("GenerateCatalogFromTextFile.CatalogFinishing.SelectedCatalogue")), 1),
                  _createElementVNode("div", null, _toDisplayString(props.generatedCatalogData.articlesInSourceCatalog), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("GenerateCatalogFromTextFile.CatalogFinishing.Source")), 1),
                  _createElementVNode("div", null, _toDisplayString(props.generatedCatalogData.articlesInSource), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("GenerateCatalogFromTextFile.CatalogFinishing.GeneratedCatalogue")), 1),
                  _createElementVNode("div", null, _toDisplayString(props.generatedCatalogData.articlesInCatalog), 1)
                ]),
                (props.generatedCatalogData.nonExistingArticles.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("GenerateCatalogFromTextFile.CatalogFinishing.SaveText")), 1),
                      _createVNode(_component_b_btn, {
                        class: "ml-3",
                        onClick: downloadCsv
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("Download")), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _createVNode(_component_b_checkbox, {
                    modelValue: openGeneratedCatalogueModel.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((openGeneratedCatalogueModel).value = $event))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("OpenGeneratedCatalogue")), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("CatalogGenerationInProgress")), 1),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(SpinnerVue)
          ])
        ]))
  ]))
}
}

})